import Component from '@glimmer/component'
import { eq } from 'ember-truth-helpers'
import { hash, array } from '@ember/helper'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import NumberSlider from 'teacher-ui-client/components/base/number-slider'

interface Signature {
  Element: HTMLDivElement
  Args: {
    primaryFilterValues: { from: number; to: number }
    primaryFilterBounds: { lower: number; upper: number }
    onUpdateValues: { from: (encodedValue: number) => unknown; to: (encodedValue: number) => unknown }
    primaryFilterValueFromFormatter: (value: number) => string
    primaryFilterValueToFormatter: (value: number) => string
  }
}

export class BookLibraryPrimaryFilterSlider extends Component<Signature> {
  get fromFormatter() {
    return this.args.primaryFilterValueFromFormatter
  }

  get toFormatter() {
    return this.args.primaryFilterValueToFormatter
  }

  get from() {
    return this.args.primaryFilterValues.from
  }

  get to() {
    return this.args.primaryFilterValues.to
  }

  get lowerBound() {
    return this.args.primaryFilterBounds.lower
  }

  get upperBound() {
    return this.args.primaryFilterBounds.upper
  }

  get fromFormatted() {
    return this.fromFormatter(this.from)
  }

  get toFormatted() {
    return this.toFormatter(this.to)
  }

  get lowerBoundFormatted() {
    return this.fromFormatter(this.lowerBound)
  }

  get upperBoundFormatted() {
    return this.toFormatter(this.upperBound)
  }

  <template>
    <div class="text-center font-medium" ...attributes>
      <span data-test-values-label>
        {{#if (eq this.fromFormatted this.toFormatted)}}
          {{this.fromFormatted}}
        {{else}}
          {{this.fromFormatted}}
          &ndash;
          {{this.toFormatted}}
        {{/if}}
      </span>
      <div class="flex items-center">
        <span data-test-lower-bound-label class="text-dusty-black-250">{{this.lowerBoundFormatted}}</span>
        <NumberSlider
          data-test-slider
          class="mx-6 grow"
          @theme={{themeKey "reading"}}
          @values={{array this.from this.to}}
          @onUpdateValues={{array @onUpdateValues.from @onUpdateValues.to}}
          @connect={{array false true false}}
          @tooltips={{array this.fromFormatter this.toFormatter}}
          @range={{hash min=this.lowerBound max=this.upperBound}}
          @step={{1}}
        />
        <span data-test-upper-bound-label class="text-dusty-black-250">{{this.upperBoundFormatted}}</span>
      </div>
    </div>
  </template>
}

export default BookLibraryPrimaryFilterSlider
